import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import '@aws-amplify/ui-vue/styles.css';

import { I18n, Auth, Hub } from 'aws-amplify';
import { translations } from '@aws-amplify/ui-vue';

import { config } from '@/config';

export const AppSetup = () => {
  I18n.putVocabularies(translations);
  I18n.putVocabulariesForLanguage('ja', {
    'Sign in': 'ログイン',
    'Forgot your password?': '※管理者の方で、パスワードを忘れた場合はこちらへ',
    'Signing in': 'ログイン中...',
    'Reset your Password': 'パスワードをリセット',
    'Code *': '確認コード *',
    'User does not exist.': 'ユーザー名またはパスワードが違います',
    'Incorrect username or password.': 'ユーザー名またはパスワードが違います',
    'User is disabled.': 'ユーザー名またはパスワードが違います',
    'Cannot reset password for the user as there is no registered/verified email or phone_number': '入力が正しくありません',
    'Username/client id combination not found.': '入力が正しくありません',
  });
  I18n.setLanguage('ja');
  const formFields = {
    signIn: {
      username: {
        label: 'ログインID',
        placeholder: 'ログインIDを入力してください',
      },
      password: {
        labelHidden: false,
        placeholder: 'パスワードを入力してください',
      }
    }
  };

  const router = useRouter();
  const store = useStore();
  Hub.listen('auth', (data) => {
    switch (data.payload.event) {
      case 'signIn':
        // フォームからのログイン、現状utサポートなし
        localStorage.removeItem(config.LSKEYWORD_CURRENTUSERTAG);
        signInUser(data.payload.data);
        break;
      case 'signOut':
      case 'signIn_failure':
      case 'tokenRefresh_failure':
        signOutUser();
        break;
      default:
        break;
    }
  });

  const signInUser = (user:any) => {
    // console.log(user);
    const storeUser = {
      username: user.username,
      groups: user.signInUserSession.idToken.payload['cognito:groups'],
      company: user.attributes['custom:company']
    };
    store.commit('setUser', storeUser);
  };
  const signOutUser = () => {
    // console.log('user signed out.');
    store.commit('removeUser');

    // 会員ID付きログインの場合は /login に飛ばす
    const customTTL = localStorage.getItem(config.LSKEYWORD_ISCUSTOMLOGIN) || '0';
    if(parseInt(customTTL) > Date.now()) {
      router.push('/login');
    } else {
      localStorage.removeItem(config.LSKEYWORD_ISCUSTOMLOGIN);
    }
  };
  
  onMounted(async () => {
    try {
      // tokenが切れた場合のリフレッシュ等で呼ばれるが、usertagがつけられず消えて上書きされる
      // 苦肉の策でusertagをlocalStorage管理にしたが、いい方法があれば書き直す
      const user = await Auth.currentAuthenticatedUser();
      signInUser(user);
    } catch (err) {
      console.warn(err);
      signOutUser();
    }
  });

  return {
    formFields
  };
};
